<h3 class="text-center text-lg mb-4">Update Available.</h3>

<div class="flex justify-center gap-4">
  <button mat-raised-button color="primary" type="button" (click)="reload()">
    Reload
  </button>

  <button mat-raised-button type="button" (click)="snackBarRef.dismiss()">
    Dismiss
  </button>
</div>
